import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormValidation } from "../../molecules/form";
import { ValidationCheckbox, ValidationInput } from "../../atoms/input";
import { StyledButtonArea } from "../../molecules/buttonArea";
import { StyledButton } from "../../atoms/button";
import "./style.scss";
import { useSearchParams } from "react-router-dom";
import PasswordChangePopup from "../../../pages/component/PasswordChangePopup";
import ForgotUserIDPopup from "../../../pages/component/ForgotUserIDPopup";
import ForgotPasswordPopup from "../../../pages/component/ForgotPasswordPopup";

const LoginForm = ({
  onLogin,
  title,
  config,
  findUserID,
  resetPassword,
  changeUserPw,
  closePwChangePopup,
  pwChangePopupFlag,
  localStorageId,
  setRememberUserId,
  rememberUserId,
  onClickSignUp = ()=>{},
  hasUserName=true
}) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [rmbMe,setRmbMe] = useState(false);

  const [forgotIDPopupFlag, setForgotIDPopupFlag] = useState(false);
  const [forgotPwPopupFlag, setForgotPwPopupFlag] = useState(false);

  useEffect(() => {
    if(rememberUserId=="true"){
      setRmbMe(true);
      if(localStorageId!=null&&localStorageId!="")
        setUserId(localStorageId);
      else
        setUserId("");
    }
    else{
      setRmbMe(false);
    }
    setPassword("");
  }, [title]);

  const changePassword = (request, cb) => {
    changeUserPw(request, () => {
      setUserId("");
      setPassword("");
      cb();
    });
  };

  return (
    <div className="form">
      <h3>{title}</h3>
      <FormValidation>
        <div className="inputs">
          <ValidationInput
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            placeholder={t("login.placeholder.id")}
            type="text"
            required={true}
          />
          <ValidationInput
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={t("login.placeholder.password")}
            type="password"
            required={true}
          />
        </div>
        <div className="util">
          <div className="input-width-label">
            <ValidationCheckbox
              id="rmbMeChkbox"
              label={t("login.rememberMe")}
              labelPosition="right"
              type="checkbox"
              required={false}
              onChange={(e) => {
                setRmbMe(e.target.checked)
                setRememberUserId(e.target.checked)}}
              checked={rmbMe}
            />
          </div>
          <ul className="list">
            {findUserID && (
              <li>
                <a onClick={() => setForgotIDPopupFlag(true)}>{t("login.forgotId")}</a>
              </li>
            )}
            {resetPassword && (
              <li>
                <a onClick={() => setForgotPwPopupFlag(true)}>{t("login.forgotPassword")}</a>
              </li>
            )}
          </ul>
        </div>
        <StyledButtonArea>
          <StyledButton
            size="lg"
            bg="primary"
            onClick={(e) => {
              e.preventDefault();
              const params = new URLSearchParams();
              params.append("userId", userId);
              params.append("password", password);
              onLogin(params);
            }}
          >
            {t("login.submit")}
          </StyledButton>
        </StyledButtonArea>
        {onClickSignUp && (
          <div className="tip">
            {t("login.signup.prompt")} <a onClick={onClickSignUp}>{t("login.signup.action")}</a>
          </div>
        )}
      </FormValidation>
      {forgotIDPopupFlag && (
        <ForgotUserIDPopup
          findUserID={findUserID}
          hasUserName={hasUserName}
          closePopup={() => setForgotIDPopupFlag(false)}
        />
      )}
      {forgotPwPopupFlag && (
        <ForgotPasswordPopup
          resetPassword={resetPassword}
          closePopup={() => setForgotPwPopupFlag(false)}
        />
      )}
      {pwChangePopupFlag && (
        <PasswordChangePopup
          changePassword={changePassword}
          closePopup={closePwChangePopup}
        />
      )}
    </div>
  );
};

export default LoginForm;
